<div class="modal fade" id="kt_modal_body_color_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Body Color' : 'Add Body Color' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="bodyColorForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Body Color Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter body color name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Body color name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Body color name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Parent Body Color -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Parent</label>
              <select
                class="form-select form-select-solid"
                formControlName="parent"
                [class.is-invalid]="parent?.invalid && parent?.touched">
                <option value="">Select Parent Body Color</option>
                <option *ngFor="let parentBodyColor of parentBodyColors" [value]="parentBodyColor._id">
                  {{ parentBodyColor.name }}
                </option>
              </select>
              <div *ngIf="isLoadingParents" class="text-muted fs-7 mt-2">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading parent body colors...
              </div>
              <div *ngIf="parent?.invalid && parent?.touched" class="invalid-feedback">
                <div *ngIf="parent?.errors?.['required']">Parent body color is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
